import React, { useState, useEffect, memo } from 'react';
import bem from 'utils/bem';
import DatePicker from './DatePicker';
import Legend from './Legend';
import TimePicker from './TimePicker';
import { buildTimesByDays, datetimeFromUTC } from 'utils/dayjs';
import { useMobile } from 'utils/media';

const { block, el } = bem('datetime-field', 'inline-datetime-field');
const InlineDateTimeField = ({ utcDates, value, selected = [], setValue = () => {}, updatePosition = () => {}, onClose = () => {}, setSaveDisabled = () => {} }) => {
    const [date, setDate] = useState(value);
    const [time, setTime] = useState(value);
    const [times, setTimes] = useState([]);

    const { isMobile } = useMobile();

    const timesByDates = buildTimesByDays(utcDates);

    const dates = Object.keys(timesByDates);

    useEffect(() => {
        if (value) {
            setDate(value);
            setTime(value);
        }
    }, [value]);

    useEffect(() => {
        if (date) {
            const { date: formattedDate } = datetimeFromUTC(date);
            setTimes(timesByDates[formattedDate]);
            if (date !== value) {
                setTime(null);
            }
        }
    }, [date])

    useEffect(() => {
        if (time) {
            setValue(time);
            setSaveDisabled(false);
            // if (value !== time) {
            //     onClose();
            // }
        } else {
            setValue(null);
            setSaveDisabled(true);
        }
    }, [time]);

    useEffect(() => {
        updatePosition();
    }, [times])

    const formattedSelectedDates = selected.filter(utcDate => !!utcDate).map(utcDate => datetimeFromUTC(utcDate).date);

    return (
        <div className={block()}>
            <div className={el('pickers')}>
                <DatePicker date={date} setDate={setDate} dates={dates} selected={formattedSelectedDates}/>
                {times.length > 0 && <TimePicker time={time} setTime={setTime} times={times} selected={selected}/>}
            </div>
        </div>
    );
};

export default memo(InlineDateTimeField);



